var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{staticClass:"section",attrs:{"lg":"12"}},[_c('VBrandLimitOfferEditList',{attrs:{"searchResults":_vm.availableOffers,"selectedOffers":_vm.selectedOffers,"busy":_vm.isBusy}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6891caea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VBrandLimitOfferEdit.vue
// module id = null
// module chunks = 